export default "__VITE_ASSET__eb7d1a5c__"